import { gql } from 'react-apollo';

export default gql`
  query offerPreview($_id: ID!) {
    offerPreview(_id: $_id) {
      _id
      name
      status
      visibility
      repName
      crdNumber
      headerImageUrl
      listingType
      sector
      investmentInstrument
      area
      typeOfOffer
      headerType
      headerVideoId
      offerPresentationTitle
      offerPresentationUrl
      stripeAccountId
      stripeProductId
      enableOfferPresentation
      minimumInvestment
      targetRaise
      offerCurrency
      valueRange
      assetStatus
      sharesForSale
      highlights
      primaryObjective
      netAcres
      county
      averageDailyProduction
      republicUrl
      republicProcessType
      wefunderUrl
      realexUrl
      wefunderProcessType
      realexProcessType
      testWatersToggle
      externalUrlSwitch
      externalUrl
      baseCurrency
      geographicMandate
      fundType
      domicileOption
      domicileOnshore
      domicileOffShore_other
      domicileOffShore
      systematicDiscretionaryOption
      investmentCoActExemptionOption
      investmentAdvisorType
      leverage
      fundStructure
      domicileOnshoreFund_other
      fundStrategyClassfication
      fundStrategyClassficationOne
      fundStrategyClassficationTwo
      fundStrategyClassficationThree
      aumfund
      fundCapacity
      trackRecordFund
      trackRecordFirm
      altOfferTitle
      documents {
        _id
        title
        url
        previewImageUrl
      }
      videoFiles {
        _id
        title
        url
        imageUrl
      }
      faqs {
        _id
        question
        answer
      }
      videoUrls
      issuerCompany {
        _id
        name
        logoUrl
        companyBackground
        isCompanyApproved
        users {
          _id
          fullName
          position
          biography
          isManagementUserApproved
          imageUrl
          order
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/queries/offerPreview.js